<template>
  <div class="spo-card rounded p-2 my-3 bordered" :class="[group_with_last ? '' : 'mt-1']">
    <div class="d-flex flex-wrap flex-sm-nowrap justify-space-between justify-center gap">
      <div class="d-flex flex-wrap gap">
        <div v-if="has_visuel" class="container_visuel_option">
          <img class="visuel_option rounded" :src="has_visuel.valeur" :alt="'visuel ' + option.nom" />
        </div>
        <div class="d-flex flex-column">
          <div class="font-weight-bold" style="margin-right: auto">{{ option.nom }}</div>

          <div class="text-body" v-if="option.information_supplementaire != ''"
            v-html="option.information_supplementaire">
          </div>
          <div class="text-body" v-if="option.information_variante_tarif != ''">{{
            option.information_variante_tarif }}
          </div>
          <div class="text-body" v-if="places_disponibles > 1">Places réservables restantes: {{ places_disponibles }}
          </div>
        </div>
      </div>

      <div class="d-flex flex-column w-100 justify-space-between gap">
        <div class="text-right text-h6"> <b>{{ option.get_text_prix() }}</b></div>
        <div v-if="is_selectionnable && max_reservable > 0" class="w-100 d-flex justify-end">
          <div v-if="is_binary_selection">
            <v-btn @click="set_quantity(0)" size="small" icon=""
              class="rounded-t rounded-b rounded-te-0 rounded-be-0 bordered px-4"
              :variant="option.quantite_souhaite == 0 ? '' : 'text'"
              :class="[option.quantite_souhaite == 0 ? 'bg-darkblue' : '']">Non</v-btn>
            <v-btn @click="set_quantity(1)" size="small" icon=""
              class="rounded-te rounded-be rounded-t-0 rounded-b-0 bordered px-4"
              :variant="option.quantite_souhaite == 1 ? '' : 'text'"
              :class="[option.quantite_souhaite == 1 ? 'bg-darkblue' : '']">Oui</v-btn>
          </div>
          <div v-else class="d-flex align-stretch">
            <v-btn @click="minus_quantity" size="small"
              class="rounded-t rounded-b rounded-te-0 rounded-be-0 bordered bg-darkblue" icon="mdi-minus"></v-btn>
            <div class="d-flex align-center justify-center bg-white  align-self-stretch px-3 bordered font-weight-bold"
              style="width: 50px;">
              <span>{{ option.quantite_souhaite }}</span>
            </div>
            <v-btn @click="plus_quantity" size="small"
              class="rounded-te rounded-be rounded-t-0 rounded-b-0 bordered bg-darkblue" icon="mdi-plus"></v-btn>
          </div>

        </div>

        <div class="justify-self-end" v-else-if="option.is_complet()">
          <v-chip square variant="elevated" elevation="0" color="dark-red">Complet</v-chip>
        </div>
        <div class="justify-self-end" v-else-if="option.is_closed()">
          <v-chip square variant="elevated" elevation="0" color="dark-red">Fermé</v-chip>
        </div>
        <div class="justify-self-end" v-else>
          <v-chip square variant="elevated" elevation="0" color="dark-red">Indisponible</v-chip>
        </div>


      </div>



    </div>



  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
export default {
  props: ["item", "group_with_last", "options_coureur", "index_inscription"],
  data() {
    return {
      desired_quantity: 0,
      option: {},
      items: [],
      max_reservable: 0,
    };
  },

  computed: {
    ...mapStores(useMainStore, useBookingStore),
    all_options() {
      return this.mainStore.module.options.list;
    },
    has_visuel() {
      let visuel = this.option.metadatas.filter((metadata) => metadata.nom == "visuel_option");
      if (visuel.length > 0) {
        return visuel[0];
      }
      return false;
    },
    places_disponibles() {
      const inscriptions = this.bookingStore.inscriptions;
      return this.option.get_places_disponibles(this.all_options, this.options_coureur, inscriptions, this.mainStore.inscription_vip, false, [], this.bookingStore.initial_commande_inscription, false, this.index_inscription, this.mainStore.bookingSystem?.groupe);
    },
    is_selectionnable() {
      return this.option.is_selectionnable('ouverte', this.mainStore.view_as_admin, this.mainStore.inscription_as_admin, this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
    },
    is_binary_selection() {
      return this.max_reservable == 1;
    }

  },

  methods: {
    set_quantity(quantity) {
      this.option.quantite_souhaite = quantity;
      this.option.handle_minimum_quantity();
      this.$emit("updateQuantite", this.option.quantite_souhaite);
    },
    minus_quantity() {
      if (this.option.quantite_souhaite > 0) {
        this.option.quantite_souhaite--;
        this.option.handle_minimum_quantity();
        this.$emit("updateQuantite", this.option.quantite_souhaite);
      }
    },
    plus_quantity() {
      if (this.places_disponibles > 0) {
        this.option.quantite_souhaite++;
        this.$emit("updateQuantite", this.option.quantite_souhaite);
      }
    },

    build_quantity_items() {
      for (let i = 0; i < this.places_disponibles; i++) {
        this.items.push(i);
      }
    },



  },
  created() {
    this.option = this.item;
    this.build_quantity_items();
    this.option.handle_minimum_quantity();
    this.max_reservable = this.option.get_places_disponibles(this.all_options, this.options_coureur, this.bookingStore.inscriptions, this.mainStore.inscription_vip, false, [], this.bookingStore.initial_commande_inscription, true, this.index_inscription);

    this.$emit("updateQuantite", this.option.quantite_souhaite);
  },
};
</script>

<style lang="scss" scoped></style>